export const css = {
    root: 'uihnkqdU',
    heading: 'uDUdfNYH',
    row: '_3ThMcuZI',
    product: '_3LnYyOEI',
    primary: 'hXsvEV9v',
    secondary: '_34qlflBN',
    sticky: '_1xm9dM02',
    leading: '_2wdK-OF1',
    title: '_1uHjMnuH',
    actions: '_3kYd1gqc',
    trailing: '_71_9FhAq',
    spacer: '_1HNY3Jjt',
    hamburgerWrapper: '_36YCSMQz',
    hamburger: '_3OnftrEy',
    hamburgerText: '_1XVDlo8l',
    hamburgerMenu: '_2puQwdwp',
    hamburgerMenuItem: '_3z5wbk5h',
    quizSelect: '_1kxkZ932',
    quizSelectBlock: '_1MHbHTDl',
    hideCountdownBlock: 'taQ3Q36I',
    quizSelectChoice: '_1QW0WEqO',
    quizSelectHidden: '_16zEN2DE',
    examCalendar: '_2Px6_rqS',
    home: '_1EJnAXxe',
    selectFadeOut: '_1UsM9TuB',
    ' _key': 'apic-theme/apic/lcc-app/heading'
};
export default css;
